import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import axios from "axios";

import * as actions from "./actiontypes";
import * as models from "./model";
import { immunisationTypeTaskApi } from "./immunisationTypeTaskApi";

import { push } from "redux-little-router";

export type ImmunisationTypeTaskAction =
      ({ type: typeof actions.LOAD_IMMUNISATIONTASKS_SUCCESS } & Payload<models.ImmunisationTypeTaskListModel[]>)
    | ({ type: typeof actions.CREATE_IMMUNISATIONTASK_SUCCESS } & Payload<models.ImmunisationTypeTaskDetailModel>)
    | ({ type: typeof actions.LOAD_IMMUNISATIONTASK_DETAIL_SUCCESS } & Payload<models.ImmunisationTypeTaskDetailModel>)
    | ({ type: typeof actions.SAVE_IMMUNISATIONTASK_SUCCESS } & Payload<models.ImmunisationTypeTaskDetailModel>)
    | ({ type: typeof actions.DELETE_IMMUNISATIONTASK_SUCCESS } & Payload<any>);

export const loadImmunisationTypeTasksSuccess = (payload: models.ImmunisationTypeTaskListModel[]): ImmunisationTypeTaskAction => ({
    payload,
    type: actions.LOAD_IMMUNISATIONTASKS_SUCCESS
});

export const createImmunisationTypeTaskSuccess = (payload: models.ImmunisationTypeTaskDetailModel): ImmunisationTypeTaskAction => ({
    payload,
    type: actions.CREATE_IMMUNISATIONTASK_SUCCESS
});

export const saveImmunisationTypeTaskSuccess = (payload: models.ImmunisationTypeTaskDetailModel): ImmunisationTypeTaskAction => ({
    payload,
    type: actions.SAVE_IMMUNISATIONTASK_SUCCESS
});

export const deleteImmunisationTypeTaskSuccess = (id: any): ImmunisationTypeTaskAction => ({
    payload: id,
    type: actions.DELETE_IMMUNISATIONTASK_SUCCESS
});

export function createImmunisationTypeTask(immunisationTypeTask: models.ImmunisationTypeTaskCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_IMMUNISATIONTYPETASK, immunisationTypeTaskApi.create(immunisationTypeTask));
        dispatch(createImmunisationTypeTaskSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveImmunisationTypeTask(immunisationTypeTask: models.ImmunisationTypeTaskEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_IMMUNISATIONTYPETASK, immunisationTypeTaskApi.save(immunisationTypeTask));

        dispatch(saveImmunisationTypeTaskSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteImmunisationTypeTask(immunisationTypeId: string, id: string, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteImmunisationTypeTask", immunisationTypeTaskApi.delete(immunisationTypeId, id));
        dispatch(deleteImmunisationTypeTaskSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export function loadImmunisationTypeTasks({ immunisationTypeId }: { immunisationTypeId: string }) {
    return async (dispatch: Dispatch) => {
        try {
            const result = await loadAndTrack(dispatch, "loadImmunisationTypeTasks", immunisationTypeTaskApi.getAllByImmunisationTypeId(immunisationTypeId));
            dispatch(loadImmunisationTypeTasksSuccess(result));
        } catch (ex) {
            if (!(ex instanceof axios.Cancel)) { // eslint-disable-line import/no-named-as-default-member
                throw ex;
            }
        }
    };
}

export const loadImmunisationTypeTasksOfType = (taskType: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadImmunisationTypeTasks", immunisationTypeTaskApi.getAllOfType(taskType));
        dispatch(loadImmunisationTypeTasksSuccess(result));
    };
};

export const loadImmunisationTypeTaskDetailSuccess = (immunisationTypeTask: models.ImmunisationTypeTaskDetailModel) => ({
    payload: immunisationTypeTask,
    type: actions.LOAD_IMMUNISATIONTASK_DETAIL_SUCCESS
});

export function loadImmunisationTypeTaskDetail({ immunisationTypeId, immunisationTypeTaskId }: { immunisationTypeId: string; immunisationTypeTaskId: string }) {
    return async (dispatch: Dispatch, getState: () => models.AppState) => {
        const immunisationTypeTask = getState().immunisationTypeTasks.filter(c => c.id === immunisationTypeTaskId)[0];

        if (immunisationTypeTask === undefined
            || !("detailUpdated" in immunisationTypeTask)
            || immunisationTypeTask.detailUpdated.isBefore(immunisationTypeTask.listUpdated)) {

            const action = immunisationTypeTask === undefined ? createImmunisationTypeTaskSuccess : loadImmunisationTypeTaskDetailSuccess;

            const result = await loadAndTrack(
                dispatch,
                "loadImmunisationTypeTaskDetail",
                immunisationTypeTaskApi.detail(immunisationTypeId, immunisationTypeTaskId)
            );
            dispatch(action(result));
        }
    };
}
